import { render, staticRenderFns } from "./BiotimeAreaFormModal.vue?vue&type=template&id=486a2974&scoped=true&"
import script from "./BiotimeAreaFormModal.vue?vue&type=script&lang=js&"
export * from "./BiotimeAreaFormModal.vue?vue&type=script&lang=js&"
import style0 from "./BiotimeAreaFormModal.vue?vue&type=style&index=0&id=486a2974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a2974",
  null
  
)

export default component.exports